module.exports = __webpack_public_path__ + "img/videogame.7ac0f545.svg";